import { render, staticRenderFns } from "./SpecialIssues.vue?vue&type=template&id=50975ffe&scoped=true"
import script from "./SpecialIssues.vue?vue&type=script&lang=js"
export * from "./SpecialIssues.vue?vue&type=script&lang=js"
import style0 from "./SpecialIssues.vue?vue&type=style&index=0&id=50975ffe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50975ffe",
  null
  
)

export default component.exports